import { render, staticRenderFns } from "./BiometryForm.vue?vue&type=template&id=466f1fbc"
import script from "./BiometryForm.vue?vue&type=script&lang=js"
export * from "./BiometryForm.vue?vue&type=script&lang=js"
import style0 from "./BiometryForm.vue?vue&type=style&index=0&id=466f1fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports